import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { poNumberList } from "./DropDownData";

export const PoNumberDropDown = ({
  value,
  isMulti = false,
  isShowAll = false,
  onSelect,
  carerTypeId,
  placeholder,
  rotaId,
  isClearable,
  disable,
  ...props
}) => {
  const [list, setList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    return () => {
      setList([]);
      setSearchString("");
    };
  }, []);

  useEffect(() => {
    if (isDropdownOpen) {
      loadPoNumberDropDownData();
    }
  }, [searchString, rotaId, isDropdownOpen]);

  const loadPoNumberDropDownData = () => {
    poNumberList(searchString, rotaId, (data, error) => {
      if (error === null) {
        if (isShowAll === false) {
          setList(data);
        }
      }
    });
  };

  const handleSearch = (text) => {
    setSearchString(text);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSelect({ id: searchString, label: searchString, value: searchString });
    }
  };

  const handleBlur = () => {
    // Save the PO number when clicking outside the dropdown
    onSelect({ id: searchString, label: searchString, value: searchString });
  };

  return (
    <RSelect
      options={list ?? []}
      disable={disable}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? (isShowAll ? (list ? list[0] : null) : null)}
      onInputChange={handleSearch}
      onMenuOpen={() => setIsDropdownOpen(true)}
      onMenuClose={() => setIsDropdownOpen(false)}
      onChange={(e) => {
        if (e === null || e === undefined) {
          onSelect({ id: searchString, label: searchString, value: searchString });
        } else {
          if (isShowAll === false) {
            onSelect(e);
          } else {
            e.id === 0 ? onSelect(undefined) : onSelect(e);
          }
        }
      }}
      onBlur={handleBlur} // Handle blur event to save PO number
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
};
